import { state } from '@angular/animations';
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    Optional,
    ViewChild,
} from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { AuthService } from '../demo/service/auth.service';
import { environment } from 'src/environments/environment';
import { WebStorage } from '../demo/components/auth/storage/web.storage';
import { DomSanitizer } from '@angular/platform-browser';
import { LookupService } from '../demo/service/lookup.service';
import { HttpResponse } from '@angular/common/http';
import { GuardianDTO } from '../demo/model/GuardianDTO';
import { StaffDTO } from '../demo/model/StaffDTO';
import { StudentDTO } from '../demo/model/StudentDTO';
import { RoomDTO } from '../demo/model/RoomDTO';
import { SchoolDTO } from '../demo/model/SchoolDTO';
import { LocalOperationService } from '../demo/service/localOperation.service';
import { Router } from '@angular/router';
import { UserNotificationsDTO } from '../demo/model/UserNotificationsDTO';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserNotificationsComponent } from '../demo/sharing/components/user-notifications/user-notifications.component';
import { UserNotificationService } from '../demo/service/userNotification.service';
import { MemberService } from '../demo/service/member.service';
import { Common } from '../demo/utils/common';
import { profielBackgroundColor } from '../demo/sharing/constants/profielBackgroundColor';
import { switchMap, forkJoin, take, catchError, map, tap, of } from 'rxjs';
import { FirestoreChatService } from '../demo/service/firestore-chat.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styles: [
        `
            .enlarge-on-hover {
                transition: transform 0.3s;
            }

            .enlarge-on-hover:hover {
                transform: scale(1.5);
                cursor: pointer;
            }
        `,
    ],
})
export class AppTopBarComponent implements OnInit {
    menu: MenuItem[] = [];
    items: MenuItem[] = [];
    @ViewChild('searchinput') searchInput!: ElementRef;
    @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('profileMenu') profileMenu!: ElementRef;
    searchActive: boolean = true;
    name: string = '';
    userdata: any = {};
    logo: undefined;
    schooldetails: any = {};
    search: any = {};
    picture: any = undefined;
    isImageLoading!: boolean;
    imageToShow!: string | ArrayBuffer | null;
    studentRelation: string | undefined;
    userRole: string | undefined = '';
    refTable: string = 'Staff';
    isAdditionalAccount: boolean = false;
    userId! : any;
    notificationsCount: number = 0;
    messageCount: number | null = null;
    isAdminUserLogin : boolean = false;
    loginPin! : any;
    showLogoutDialog = false;
    showChangePasswordDialog = false;
    changePasswordLoading = false;
    guardianData!: any;
    activeGuardianAllStudents: StudentDTO[] = [];
    activeStudent: StudentDTO = {};
    withoutActiveStudent: StudentDTO[] = [];
    backgroundColors: string[] = [];
    schoolData : SchoolDTO = {};
    roomNameMap: { [id: string]: any } = {};

    private unreadSubscription: Subscription | null = null;
    private currentUnreadKey: string | null = null;


    constructor(
        public layoutService: LayoutService,
        private authService: AuthService,
        private lookupService: LookupService,
        private sanitizer: DomSanitizer,
        private storage: WebStorage,
        private cdr: ChangeDetectorRef,
        private localOperationService: LocalOperationService,
        private router: Router,
        private memberService : MemberService,
        public dialogService: DialogService,
        @Optional() public ref: DynamicDialogRef,
        private userNotificationService : UserNotificationService,
        private messageService : MessageService,
        private firestoreChatService: FirestoreChatService

    ) {
        this.backgroundColors = profielBackgroundColor
     }

     ngOnInit() {
      const stored = localStorage.getItem('user-profile');
      this.isAdminUserLogin = Common.isAdminUserLogin(this.storage);
      if (stored) {
          const parsed = JSON.parse(stored);
          this.userdata = {
              ...parsed,
              firstName: `${parsed.firstName || ''} ${parsed.lastName || ''}`.trim()
          };
      }
  
      this.memberService.name$.subscribe((data: any) => {
          if (data) {
              this.userdata.firstName = `${data.firstName || ''} ${data.lastName || ''}`.trim();
          }
      });
  
      if (this.userdata?.id) {
          this.userId = `user_${this.userdata.id}`;
  
          this.userNotificationService.fetchAndUpdateCount(this.userId);
  
          this.userNotificationService.unreadCount$.subscribe((count: number) => {
              this.notificationsCount = count;              
          });
  
          // Setup real-time unread count from Firestore
          this.setupUnreadListener();
      }
  
      this.activateSearch();
  
      this.schooldetails = {
          description: undefined,
          id: undefined,
          name: undefined,
          schoolId: this.userdata.schoolId,
          status: 'A',
          logo: undefined,
      };
  
      if (this.userdata != null) {
          if (this.userdata.refTable == 'Staff') {
              this.refTable = 'Guardian';
              this.queryUserRoleRelation();
          } else if (this.userdata.refTable == 'Guardian') {
              this.refTable = 'Staff';
              this.queryGuardian();
          }
  
          this.queryUserProfilePicture(); 
          this.lookupService.queryAccountCount({ 'ssoKey.equals': this.userdata.ssoKey }).subscribe((req: HttpResponse<any>) => {
              this.isAdditionalAccount = req.body == 2 ? true : false;
          });
  
          this.userNotificationService.fetchAndUpdateCount(this.userId);
      }
  
      this.memberService.getSchoolDetailsChanged$().subscribe(() => {
          this.querySchoolName();
          this.queryUserProfilePicture(); 
          this.queryUserRoleRelation();
      });
  
      this.querySchoolName();
      this.queryUserProfilePicture(); 
  }

  private setupUnreadListener(): void {
    this.unreadSubscription?.unsubscribe();

    if (!this.userdata?.refTableId) {
      this.messageCount = 0;
      return;
    }

    const isStaff = this.userdata.refTable?.toLowerCase() === 'staff';

    if (isStaff) {
      const staffKey = `staff_${this.userdata.refTableId}`;
      this.currentUnreadKey = staffKey;
      this.unreadSubscription = this.firestoreChatService
        .watchUserUnread(staffKey)
        .subscribe(count => {
          this.messageCount = count;
          this.cdr.detectChanges();
        });
    } else {
      // Guardian: read activeStudent from localStorage immediately — no API wait needed
      if (!this.activeStudent?.id) {
        const stored = localStorage.getItem('activeStudent');
        if (stored) this.activeStudent = JSON.parse(stored);
      }
      if (this.activeStudent?.id) {
        this.updateGuardianUnread();
      }
      // queryGuardian() will also call updateGuardianUnread() once API confirms the student
    }
  }

  private updateGuardianUnread(): void {
    this.unreadSubscription?.unsubscribe();

    if (!this.activeStudent?.id || !this.userdata?.refTableId) {
      this.messageCount = 0;
      return;
    }

    const guardianKey = `guardian_${this.userdata.refTableId}`;
    this.currentUnreadKey = `student_${this.activeStudent.id}`;

    this.unreadSubscription = this.firestoreChatService
      .watchActiveStudentUnread(this.activeStudent.id.toString(), guardianKey)
      .subscribe(count => {
        this.messageCount = count;
        this.cdr.detectChanges();
      });
  }

  // Call this when guardian switches active student
  onActiveStudentChanged(): void {
    if (this.userdata?.refTable?.toLowerCase() === 'guardian') {
      this.updateGuardianUnread();
    }
  }

  openCommunication(): void {
    this.router.navigate(['/communication']);
  }
  

    ngAfterViewInit() {
        this.localOperationService.schoolMessage.subscribe(massage => {
            if (massage == true) {
                this.queryData()
            }
        })
    }

    queryData() {
        // this.lookupService
        //     .getSchoolById(this.userdata.schoolId)
        //     .subscribe(async (res: HttpResponse<SchoolDTO>) => { 
                

        //     });
        this.schooldetails = this.storage.getUserData().schoolObj;        
                if (this.schooldetails.id) {
                    this.fetchSchoolImg(this.schooldetails);
                }
    }

    querySchoolName(){
                this.lookupService
            .getSchoolById(this.userdata.schoolId)
            .subscribe(async (res: HttpResponse<SchoolDTO>) => { 
                this.schoolData = res.body ? res.body : {};
            });
    }

    queryUserProfilePicture(): void {
      if (!this.userdata) return;
  
      let queryParams;
      if (this.userdata.refTable == 'Staff') {
          queryParams = {
              'docType.equals': 'PROFILE',
              'refTable.equals': 'Staff',
              'refTableId.equals': this.userdata.refTableId,
              'schoolId.equals': this.userdata.schoolId,
              'status.equals': 'A',
          };
      } else if (this.userdata.refTable == 'Guardian') {
          queryParams = {
              'docType.equals': 'PROFILE',
              'refTable.equals': 'Guardian',
              'refTableId.equals': this.userdata.refTableId,
              'schoolId.equals': this.userdata.schoolId,
              'status.equals': 'A',
          };
      }
  
      this.lookupService
          .queryAllDocuments(queryParams)
          .subscribe((req: Blob) => {
              if (req.size != 0) {
                  this.createImageFromBlob(req);
                  this.isImageLoading = false;
              } else {
                  this.picture = undefined;
              }
          });
  }
  

    getInitials(name: string): string {
        if (!name) return '';
        const words = name.split(' ');
        let initials = '';
        for (let i = 0; i < words.length; i++) {
            initials += words[i].charAt(0).toUpperCase(); // Get the first letter of each word and capitalize it
        }
        return initials.slice(0, 2); // Ensure only the first two initials are used
    }
    

    fetchSchoolImg(school: SchoolDTO) {
        if (school.logo) {
            this.lookupService
                .queryDocumentByPhotoUid(school.logo)
                .subscribe((response: HttpResponse<Blob>) => {
                    const body = response?.body;
                    if (body) {
                        const url = this.createImgFromBuffer(body);
                        school.logoUrl = url;
                    }
                });
        }
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }



    async queryGuardian() {
        this.search = { 'id.equals': this.userdata.refTableId };
      
        this.lookupService.queryGuardian(this.search).subscribe(async (res: HttpResponse<GuardianDTO[]>) => {
          const guardians: GuardianDTO[] = res.body ?? [];
          this.guardianData = guardians[0];
      
          const students: StudentDTO[] = this.guardianData?.students ?? [];
          this.activeGuardianAllStudents = students;
      
          const storedStudent = localStorage.getItem('activeStudent');
          this.activeStudent = storedStudent
            ? JSON.parse(storedStudent)
            : students[0] ?? {};
      
          localStorage.setItem('activeStudent', JSON.stringify(this.activeStudent));
      
          this.withoutActiveStudent = students.filter(s => s.id !== this.activeStudent?.id);
      
          // Process remaining students in parallel
          await Promise.all(this.withoutActiveStudent.map(student => this.enrichStudentData(student)));
      
          this.studentRelation = this.guardianData?.relation ?? '';
          this.updateGuardianUnread();
        });
      }

      private async enrichStudentData(student: StudentDTO): Promise<void> {
        if (!student?.id) return;
        
        // const studentRes = await this.lookupService.getStudentById(student.id).toPromise();
        // if (studentRes?.body?.roomId) {
        //   student.roomId = studentRes.body.roomId;
      
        //   const roomRes = await this.lookupService.getRoomById(student.roomId).toPromise();
        //   student.roomName = roomRes?.body?.name ?? '';
        // }
      
        if (student.photoUuid) {
          this.lookupService.queryDocumentByPhotoUid(student.photoUuid).subscribe((response: HttpResponse<Blob>) => {
            const body = response?.body;
            student.profileimg = body && body.size > 0
              ? this.sanitizer.bypassSecurityTrustResourceUrl(this.createImgFromBuffer(body))
              : undefined;
          });
        } else {
          student.profileimg = undefined;
        }
      }
      
      


    queryUserRoleRelation() {
        this.search = {};
        this.search['id.equals'] = this.userdata.refTableId;
        this.search['schoolId.equals'] = this.userdata.schoolId;
        this.search['designation.notEquals'] = 'Kiosk';
        this.lookupService
            .queryStaff(this.search)
            .subscribe((res: HttpResponse<StaffDTO[]>) => {
                this.userRole = res.body
                    ? res.body[0]?.designation
                    : undefined;
                this.userRole = this.userRole ? `${this.userRole}` : '';
               const getClockInPin =  res?.body?.map((res : any) => {
                    this.loginPin  = res?.clockInPin;
                })          
            });
    }

    // queryUserRoleRelation(user: any) {
    //     this.lookupService.queryUserRole({ 'userId': user.id }).subscribe((res: HttpResponse<any>) => {
    //       const userRelation = res.body;                
    //       if (userRelation) {
    //         switch (true) {
    //           case userRelation.roles.some((role: any) => role.name.includes("ROLE_ADMIN")):
    //             this.userRole = "Admin";
    //             break;
    //           case userRelation.roles.some((role: any) => role.name.includes("ROLE_STAFF")):
    //             this.userRole = "Staff";
    //             break;
    //           case userRelation.roles.some((role: any) => role.name.includes("ROLE_DIRECTOR")):
    //             this.userRole = "Director";
    //             break;
    //           default:
    //             this.userRole = "Staff";
    //             return;
    //         }      
    //       }
    //     });
    // }




    createImageFromBlob(image: Blob) {
        let reader = new FileReader();
        reader.addEventListener(
            'load',
            () => {
                this.imageToShow = reader.result;
                this.picture = this.sanitizer.bypassSecurityTrustResourceUrl(
                    '' + this.imageToShow
                );
            },
            false
        );

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
          if (this.searchInput?.nativeElement) {
            this.searchInput.nativeElement.focus();
          }
        }, 100);
      }
      

    deactivateSearch() {
        this.searchActive = false;
    }

    removeTab(event: MouseEvent, item: MenuItem, index: number) {
        this.layoutService.onTabClose(item, index);
        event.preventDefault();
    }

    get layoutTheme(): string {
        return this.layoutService.config.layoutTheme;
    }

    get colorScheme(): string {
        return this.layoutService.config.colorScheme;
    }

    // get logo(): string {
    //     const path = 'assets/layout/images/wise_owl_logo';
    //     // const logo = (this.layoutTheme === 'primaryColor'  && !(this.layoutService.config.theme  == "yellow")) ? 'light.png' : (this.colorScheme === 'light' ? 'dark.png' : 'light.png');
    //     return path;
    // }

    get tabs(): MenuItem[] {
        return this.layoutService.tabs;
    }

    // Logout() {
    //     this.storage.logout();
    //     setTimeout(() => {
    //         this.keycloak
    //             .logout(window.location.origin + environment.path)
    //             .then((data) => {});
    //     }, 2000);
    // }

    confirmLogout(): void {
        this.showLogoutDialog = false;
        this.Logout(); 
    }

    async Logout() {
        // Clean up subscriptions to prevent memory leaks
        this.userNotificationService.clearUnreadCountSubscription();
        this.memberService.clearUnreadCountSubscription();

        await this.authService.logout();
        this.userdata = this.storage.getUserData();
        this.cdr.detectChanges();
    }

    showBellNotificationDialog() {
        const tempData: any = {
          data: this.userdata,
        };
      
        this.ref = this.dialogService.open(UserNotificationsComponent, {
          data: tempData,
          header: 'Notifications',
          width: '418px',
          contentStyle: {
            overflow: 'auto',
            height: '523.5px'
          },
          baseZIndex: 10000,
          position: 'topright',
          // allow closing when clicking outside the dialog
          dismissableMask: true,
          closable: true
        });
      
        this.ref.onClose.subscribe((res: any) => {
          this.queryData();
        });
      }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

    onAccountChange(refTable: string) {
        localStorage.removeItem('logQueryParam');
        localStorage.setItem('logQueryParam', refTable);
        localStorage.removeItem('activeStudent');
        // window.location.reload();
        window.location.href = ''
    }

    studentProfileChange(student: StudentDTO) {
        this.activeStudent = student;
        this.onActiveStudentChanged(); // Update unread count for new active student
        localStorage.removeItem('activeStudent');
        localStorage.setItem('activeStudent', JSON.stringify(student));

        const tempStudent: StudentDTO[] = [];
        this.withoutActiveStudent = this.activeGuardianAllStudents ? this.activeGuardianAllStudents.filter(each => each.id !== this.activeStudent?.id) : tempStudent;    
        this.withoutActiveStudent.forEach(async (student) => {
            this.lookupService
                .queryAllDocuments({
                    'docType.equals': 'PROFILE',
                    'refTableId.equals': student.id,
                    'refTable.equals': 'Student',
                })
                .subscribe((req: Blob) => {
                    let reader = new FileReader();
                    reader.addEventListener(
                        'load',
                        () => {
                            let imageToShow:
                                | string
                                | ArrayBuffer;
                            if (reader.result) {
                                imageToShow = reader.result;
                                student.profileimg =
                                    this.sanitizer.bypassSecurityTrustResourceUrl(
                                        '' + imageToShow
                                    );
                            } else {
                                // Handle the case where reader.result is null (if needed)
                                // You can assign a default value or handle it differently.
                            }
                        },
                        false
                    );

                    if (req.size != 0) {
                        reader.readAsDataURL(req);
                    } else {
                        student.profileimg = undefined;
                    }
                });
        });
        window.location.href = '';
        this.router.navigateByUrl('');

    }

    onChangePassword(): void {
        this.closeProfileMenu();
        this.showChangePasswordDialog = true;
      }
      
      async onConfirmChangePassword(): Promise<void> {
        const email = this.userdata?.login;
        if (email) {
          this.changePasswordLoading = true;
          try {
            await this.authService.forgotPassword(email);
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Password reset link sent successfully!',
              life: 3000,
            });
            this.showChangePasswordDialog = false;
            // Force logout after successful password reset request with delay to show success message
            setTimeout(async () => {
              await this.Logout();
            }, 2000);
          } catch (error) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to send password reset link.',
              life: 3000,
            });
          } finally {
            this.changePasswordLoading = false;
          }
        }
      }

      goToUserProfile() {
        this.closeProfileMenu();
        this.router.navigate(['/user-profile/profile']);
      }

      // Hide the profile dropdown/popup by adding back the 'hidden' class
      closeProfileMenu(): void {
        try {
            const el: HTMLElement = this.profileMenu?.nativeElement;
            if (el && !el.classList.contains('hidden')) {
                el.classList.add('hidden');
            }
        } catch (e) {
            // ignore if not available
        }
      }

      isChildrenDropdownOpen = false;

toggleChildrenDropdown() {
  this.isChildrenDropdownOpen = !this.isChildrenDropdownOpen;
}

getBackgroundColor(roomId: any) {
    if (!roomId) return this.backgroundColors[0];
    const index = (roomId - 1) % this.backgroundColors.length;
    return this.backgroundColors[index];
  }

  openHelpLink(): void {
    window.open('http://help.Childcarewow.com', '_blank');
  }


async getRoomName(roomId: any): Promise<string> {
  if (!roomId) return 'No Room';

  if (this.roomNameMap[roomId]) {
    return this.roomNameMap[roomId]; 
  }

  try {
    const res = await this.lookupService.getRoomById(roomId).toPromise();
    const name = res?.body?.name || 'No Room';
    this.roomNameMap[roomId] = name; 
    return name;
  } catch (e) {
    return 'No Room'; 
  }
}

  ngOnDestroy(): void {
    this.unreadSubscription?.unsubscribe();
  }
}
